import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MmFlexLayoutModule } from '@metromarkets/components';
import { QaLocatorsModule } from '@metromarkets/sdk';
import { TranslateModule } from '@ngx-translate/core';
import { FlexModule } from '@angular/flex-layout';
import { KebabCaseModule } from '~shared/pipes';
import { BasePageModule } from '~shared/modules/base-page/base-page.module';
import { BreadcrumbsModule } from '~shared/components/breadcrumbs/breadcrumbs.module';
import { LandingPageRoutingModule } from './landing-page.routing.module';
import { LandingPageComponent } from './components';
import { MmExpansionModule } from '~shared/modules/mm-expansion/mm-expansion.module';
import { DynamicModule } from 'ng-dynamic-component';
import {
  StoryblokEditableModule
} from '~app/modules/storyblok/directives/storyblok-editable/storyblok-editable.module';

@NgModule({
  declarations: [LandingPageComponent],
  imports: [
    CommonModule,
    LandingPageRoutingModule,
    MmFlexLayoutModule,
    TranslateModule,
    QaLocatorsModule,
    KebabCaseModule,
    BasePageModule,
    BreadcrumbsModule,
    FlexModule,
    MmExpansionModule,
    DynamicModule,
    StoryblokEditableModule
  ],
})
export class LandingPageModule {}
